import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import "./config/cognito";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

type AuthState = "loading" | "authenticated" | "unauthenticated";

function App() {
  const [authState, setAuthState] = useState<AuthState>("loading");

  useEffect(() => {
    Auth.currentSession()
      .then(() => setAuthState("authenticated"))
      .catch(() => setAuthState("unauthenticated"));
  }, []);

  if (authState === "loading") {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (authState === "unauthenticated") {
    return <Login onLogin={() => setAuthState("authenticated")} />;
  }

  return <Dashboard onLogout={() => setAuthState("unauthenticated")} />;
}

export default App;
